import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-combobox.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-combobox.component.css?ngResource";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from "rxjs";
let CalciteComboboxComponent = class CalciteComboboxComponent {
    changeDetectorRef;
    comboboxItemsObservable = new Subject();
    setItemsAsSelectedObservable = new Subject();
    allowCustomValues = false;
    disableComboBox = false;
    comboBoxPlaceholder = undefined;
    comboBoxScale = "s" /* ComboboxScale.small */;
    maxItems = 5;
    overlayPositioning = "absolute" /* ComboboxOverlayPositioning.absolute */;
    label = undefined;
    setSelectedItems = [];
    onComboBoxChange = new EventEmitter();
    comboBoxOptions = [];
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.setSubscribers();
    }
    onChange($event) {
        if ($event && $event.detail.selectedItems.length > 0) {
            const selectedItems = [];
            $event.detail.selectedItems.forEach((element) => {
                selectedItems.push(element.value);
            });
            this.onComboBoxChange.next(selectedItems);
        }
    }
    setComboBoxItems(comboBoxItem, elementId, comboBoxElement) {
        const comboBoxItemHTMLElement = document.createElement("calcite-combobox-item");
        comboBoxItemHTMLElement.setAttribute("id", elementId.toString());
        comboBoxItemHTMLElement.setAttribute("text-label", comboBoxItem.value);
        comboBoxItemHTMLElement.setAttribute("value", comboBoxItem.code);
        comboBoxElement?.appendChild(comboBoxItemHTMLElement);
    }
    setItemsAsSelected(selectedItems, comboBoxItemHTMLElement) {
        const comboBoxListItemNodes = comboBoxItemHTMLElement.childNodes;
        comboBoxListItemNodes.forEach((calciteNodeItem) => {
            const itemValue = calciteNodeItem?.value;
            for (const selectedItem of selectedItems) {
                if (itemValue.toLowerCase() == selectedItem.toLowerCase()) {
                    calciteNodeItem.setAttribute("selected", "true");
                }
            }
        });
    }
    setSubscribers() {
        const comboBoxElement = document.getElementById("comboBox");
        this.comboboxItemsObservable.subscribe(comboBoxItems => {
            if (comboBoxItems && comboBoxItems.length > 0) {
                this.comboBoxOptions = comboBoxItems;
                comboBoxItems.forEach((comboBoxItem, i) => {
                    const id = i + 1;
                    this.setComboBoxItems(comboBoxItem, id, comboBoxElement);
                });
                this.changeDetectorRef.detectChanges();
            }
        });
        this.setItemsAsSelectedObservable.subscribe((items) => {
            if (items && items.length > 0) {
                this.setItemsAsSelected(items, comboBoxElement);
            }
        });
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        comboboxItemsObservable: [{ type: Input }],
        setItemsAsSelectedObservable: [{ type: Input }],
        allowCustomValues: [{ type: Input }],
        disableComboBox: [{ type: Input }],
        comboBoxPlaceholder: [{ type: Input }],
        comboBoxScale: [{ type: Input }],
        maxItems: [{ type: Input }],
        overlayPositioning: [{ type: Input }],
        label: [{ type: Input }],
        setSelectedItems: [{ type: Input }],
        onComboBoxChange: [{ type: Output }]
    };
};
CalciteComboboxComponent = __decorate([
    Component({
        selector: 'lib-calcite-combobox',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteComboboxComponent);
export { CalciteComboboxComponent };
